<i18n>
{
	"en": {
		"title": "Deviation Cause"
	},
	"no": {
		"title": "Avviksårsak"
	}
}
</i18n>

<template>
	<t-combobox
		:title="$t('title')"
		:showCount="false"
		showPopoverOnFocus

		:searchValue="searchValue"
		:items="deviationCauses"
		:selected="value"

		:disabled="disabled || hasNoDeviationCauses"

		:filterFunction="filterFunction"
		:sortFunction="sortFunction"

		@input="onInput"
		@change="onChange"
		@blur="onBlur"
	>
		<template #optionItemContent="slotProps">
			<div class="item">
				<div class="item-main-text">{{ `${slotProps.item.code} - ${slotProps.item.description}` }}</div>
			</div>
		</template>
	</t-combobox>
</template>

<script>
import { mapState, mapActions } from './store/deviations.store';

export default {
	name: 'DeviationCauseInput',
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			searchValue: '',
		};
	},
	computed: {
		...mapState(['deviationCauses']),
		hasNoDeviationCauses() {
			return !this.deviationCauses || this.deviationCauses.length === 0;
		},
	},
	watch: {
		value: {
			immediate: true,

			handler(deviationCause) {
				if (!deviationCause || Object.keys(deviationCause).length === 0) {
					this.searchValue = '';
				} else if (deviationCause.code) {
					this.searchValue = deviationCause.code;
				}
			}
		}
	},
	async created() {
		await this.getDeviationCauses();
	},
	methods: {
		...mapActions(['getDeviationCauses']),

		onInput(searchValue) {
			this.searchValue = searchValue.toUpperCase();
		},

		onChange(event) {
			if (event && event.code) {
				this.searchValue = event.code;
				this.$emit('change', event);
			} else
				this.$emit('change', undefined);
		},

		onBlur() {
			if (this.searchValue === '') {

				this.$emit('change', undefined);
				return;
			}

			let deviationCause = this.deviationCauses.find(
				deviationCause => this.searchValue.toLowerCase() === deviationCause.code.toLowerCase()
			);

			if (deviationCause && deviationCause !== this.value) {
				this.$emit('change', deviationCause);

			} else
				this.searchValue = this.getSearchValueFromValue(this.value);
		},
		getSearchValueFromValue(value) {
			if (value && value.code && value.code.length)
				return value.code;
			else
				return '';
		},

		filterFunction(deviationCause) {
			return deviationCause.code.toLowerCase().includes(this.searchValue.toLowerCase());
		},
		sortFunction: (a, b) => {
			if (a.code < b.code) return -1;
			if (a.code > b.code) return 1;
			return 0;
		},
	}
};
</script>
